import * as React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

type DashboardListTableProps = {
  data: { name: string; value: number }[];
  metric?: { id: number; name: string };
};

export default function DashboardListTable({ data, metric }: DashboardListTableProps) {
  const totalValue = data?.reduce((sum, item) => sum + item.value, 0);
  const metricId = metric?.id;

  // 1. Define conditional padding based on metricId
  // If not metric 2, we use a very small value (e.g., 0.3) to reduce row height
  const rowPaddingY = metricId === 2 ? 1 : 0.6;
  const rowPaddingX = metricId === 2 ? 3 : 1.5;

  return (
    <Paper elevation={6} sx={{ p: 2, borderRadius: 3, height: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: '100%' }}>
        <Table
          size="small"
          sx={{
            '& .MuiTableCell-root': {
              borderBottom: 'none',
              fontSize: '0.92rem',
              // Base padding override
              py: rowPaddingY,
              px: rowPaddingX,
            },
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: '#eef3ff' }}>
              <TableCell
                sx={{
                  py: 1.2, // Keep header slightly larger for readability
                  fontWeight: 600,
                  color: '#1f3c88',
                  borderRadius: '8px 0 0 8px',
                }}
              >
                {metricId === 2 ? 'Acceptance' : 'Rating'}
              </TableCell>

              <TableCell
                align="right"
                sx={{
                  py: 1.2,
                  fontWeight: 600,
                  color: '#1f3c88',
                  borderRadius: '0 8px 8px 0',
                }}
              >
                Number
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row) => (
              <TableRow key={row.name} hover>
                <TableCell sx={{ color: '#555', py: rowPaddingY }}>{row.name}</TableCell>
                <TableCell align="right" sx={{ color: '#555', py: rowPaddingY }}>
                  {row.value.toLocaleString()}
                </TableCell>
              </TableRow>
            ))}

            {/* Total Row */}
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: '#003399',
                  borderTop: '1px solid #adc8ff',
                  py: rowPaddingY + 0.5, // Total row slightly taller
                }}
              >
                Total
              </TableCell>

              <TableCell
                align="right"
                sx={{
                  fontWeight: 700,
                  color: '#003399',
                  borderTop: '1px solid #adc8ff',
                  py: rowPaddingY + 0.5,
                }}
              >
                {totalValue.toLocaleString()}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
